/**
 * Baixa um CSV que o Excel abre direto (";" como separador, BOM do UTF-8 para os acentos).
 * linhas: a primeira é o cabeçalho; cada linha é uma lista de valores.
 */
export function baixarCsv(nomeArquivo, linhas) {
    const texto = linhas
        .map(colunas => colunas.map(c => `"${String(c ?? "").replace(/"/g, '""')}"`).join(";"))
        .join("\r\n");
    const url = URL.createObjectURL(new Blob([`﻿${texto}`], { type: "text/csv;charset=utf-8" }));
    const link = document.createElement("a");
    link.href = url;
    link.download = nomeArquivo;
    link.click();
    URL.revokeObjectURL(url);
}

const formatoDecimalCsv = new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: false });

/** Número com vírgula decimal (o Excel em português lê como número). */
export const decimalCsv = (valor) => (valor === null || valor === undefined || valor === "" ? "" : formatoDecimalCsv.format(Number(valor)));
